import _mapInstanceProperty from '@babel/runtime-corejs3/core-js/instance/map';
import * as React from 'react';
import { mobile, login } from '@bilibili-maoer/web-utils';
import classNames from 'classnames';
import { compact } from 'lodash-es';
import { prependPrefix } from '../../utils/style.js';

var thirdPartyConfigs = compact([{
  type: 'qq',
  title: 'QQ'
}, {
  type: 'weibo',
  title: '微博'
}, {
  type: 'bilibili',
  title: 'bilibili'
}, !mobile.isMobile() && {
  type: 'wechat',
  title: '微信'
}]);
var ThirdPartyLogin = function ThirdPartyLogin(_ref) {
  var className = _ref.className;

  var handleClick = function handleClick(type) {
    var href = login.getThirdLoginUrl(type);

    if (window.self === window.top) {
      window.location.href = href;
    } else {
      if (!window.top) return;
      window.top.location.href = href;
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classNames(prependPrefix('third-party-login'), className)
  }, /*#__PURE__*/React.createElement("div", {
    className: "login-title"
  }, "\u7B2C\u4E09\u65B9\u767B\u5F55"), /*#__PURE__*/React.createElement("div", {
    className: "login-types"
  }, _mapInstanceProperty(thirdPartyConfigs).call(thirdPartyConfigs, function (_ref2) {
    var type = _ref2.type,
        title = _ref2.title;
    return /*#__PURE__*/React.createElement("a", {
      key: type,
      className: "login-".concat(type),
      title: title,
      onClick: function onClick() {
        return handleClick(type);
      }
    });
  })));
};

export { ThirdPartyLogin };
